/*
 * Copyright (C) 2020 Robert Bosch GmbH Copyright (C) 2020 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { ModuleWithProviders, NgModule } from "@angular/core";
import { NO_VALUE_PLACEHOLDER } from "./no-value-placeholder";
import { NoValuePipe } from "./no-value.pipe";

@NgModule({
  declarations: [NoValuePipe],
  exports: [NoValuePipe]
})
export class NoValuePipeModule {}
